var map = {
	"./BuildLimit.webp": "8e62",
	"./HealArea.webp": "239a",
	"./Self_Heal.webp": "713e",
	"./US_AreaDamage_ua.webp": "9759",
	"./US_BonusDamageProtections_ua.webp": "757f",
	"./US_BonusDamagevsBuilding_ua.webp": "dfad",
	"./US_BonusDamagevsCavalry_ua.webp": "5aa3",
	"./US_BonusDamagevsHuntable_ua.webp": "e006",
	"./US_BonusDamagevsInfantry_ua.webp": "171f",
	"./US_BonusDamagevsPriests_ua.webp": "440c",
	"./US_BonusDamagevsRanged_ua.webp": "7f59",
	"./US_BonusDamagevsShip_ua.webp": "09d3",
	"./US_BonusDamagevsSiege_ua.webp": "4a10",
	"./US_BonusDamagevsVillager_ua.webp": "b43a",
	"./US_BuildTime_ua.webp": "d9ed",
	"./US_CavArmor_ua.webp": "769e",
	"./US_CavalryDPS_ua.webp": "8809",
	"./US_ChaosRate_ua.webp": "db5f",
	"./US_ConvertRate_ua.webp": "0400",
	"./US_ConvertResist_ua.webp": "1b88",
	"./US_Cost_ua.webp": "a543",
	"./US_CrushDPS_ua.webp": "519b",
	"./US_DamageOverTime_ua.webp": "98c6",
	"./US_FoodGatherRate_ua.webp": "a443",
	"./US_GoldGatherRate_ua.webp": "a47d",
	"./US_HealRate_ua.webp": "d244",
	"./US_Heal_ua.webp": "45f9",
	"./US_IgnoreArmor_ua.webp": "13c8",
	"./US_InfArmor_ua.webp": "0896",
	"./US_MaxHealth_ua.webp": "c2d2",
	"./US_MeleeDPS_ua.webp": "3f2e",
	"./US_RangeDPS_ua.webp": "b7be",
	"./US_RangedArmor_ua.webp": "aaa6",
	"./US_ResourceFood_ua.webp": "8966",
	"./US_ResourceGold_ua.webp": "ea06",
	"./US_ResourceStone_ua.webp": "0635",
	"./US_ResourceWood_ua.webp": "452d",
	"./US_SeigeArmor_ua.webp": "9120",
	"./US_SightRange_ua.webp": "4507",
	"./US_SnareResist_ua.webp": "6b33",
	"./US_Snare_ua.webp": "06ce",
	"./US_Speed_ua.webp": "9eaf",
	"./US_SplashDamageArmor_ua.webp": "0061",
	"./US_StoneGatherRate_ua.webp": "65c1",
	"./US_WeaponRange_ua.webp": "c0af",
	"./US_WoodGatherRate_ua.webp": "b674"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a74b";